import modelmain from "./363_MainSeat.glb";
import ribs from "./363_Ribs.glb";
import logomain from "./363_MainLogo.glb";
import logohexa from "./363_HexaLogo.glb";
import leftBolt from "./363_SideLogoLeftBolt.glb";
import leftEnjoy from "./363_SideLogoLeftEnjoy.glb";
import rightEnjoy from "./363_SideLogoRightEnjoy.glb";
import rightBolt from "./363_SideLogoRightBolt.glb";
import rightKawasaki from "./363_SideLogoRightKawasaki.glb";
import rightYamaha from "./363_SideLogoRightYamaha.glb";
import rightHonda from "./363_SideLogoRightHonda.glb";
import number from "./363_Number.glb";
import leftKawasaki from "./363_SideLogoLeftKawasaki.glb";
import leftYamaha from "./363_SideLogoLeftYamaha.glb";
import leftHonda from "./363_SideLogoLeftHonda.glb";

// This is the main Scooter seat Model (AKA Honda Navi)
// Link to test
// /?type=scooter&subtype=ribbed&test=yes

const modelParts = {
  main: modelmain,
  ribs: ribs,
  logoMain: logomain,
  logoHexa: logohexa,
  number: number,
};

const leftLogoParts = {
  bolt: leftBolt,
  enjoyMfg: leftEnjoy,
  yamaha: leftYamaha,
  honda: leftHonda,
  kawasaki: leftKawasaki,
};
const rightLogoParts = {
  bolt: rightBolt,
  enjoyMfg: rightEnjoy,
  yamaha: rightYamaha,
  honda: rightHonda,
  kawasaki: rightKawasaki,
};

const leftLogoCoords = {
  bolt: {
    position: [0.125, -0.11, 0.202],
    rotation: [1.574, 0.001, -1.222],
    scale: 0.284,
  },
  enjoyMfg: {
    position: [0.121, -0.097, 0.215],
    rotation: [1.605, 0.291, -1.209],
    scale: 0.484,
  },
  yamaha: {
    position: [0.12, -0.1, 0.222],
    rotation: [1.607, 0.292, -1.209],
    scale: 0.779,
  },
  honda: {
    position: [0.128, -0.096, 0.197],
    rotation: [1.607, 0.292, -1.209],
    scale: 0.779,
  },
  kawasaki: {
    position: [0.121, -0.097, 0.212],
    rotation: [1.654, 0.047, -1.239],
    scale: 0.3,
  },
};
const rightLogoCoords = {
  bolt: {
    position: [-0.126, -0.099, 0.199],
    rotation: [1.579, -0.003, 1.217],
    scale: 0.283,
  },
  enjoyMfg: {
    position: [-0.118, -0.097, 0.214],
    rotation: [1.612, -0.294, 1.21],
    scale: 0.484,
  },
  yamaha: {
    position: [-0.136, -0.092, 0.168],
    rotation: [1.61, -0.293, 1.209],
    scale: 0.779,
  },
  honda: {
    position: [-0.126, -0.095, 0.192],
    rotation: [1.61, -0.293, 1.209],
    scale: 0.779,
  },
  kawasaki: {
    position: [-0.13, -0.094, 0.186],
    rotation: [1.677, -0.054, 1.239],
    scale: 0.3,
  },
};

const numberCoords = {
  modelPosition: [0.002, 0.113, -0.276],
  modelRotation: [0, 0, 0],
  textPosition: [-0.035, -0.13, 0],
  textRotation: [Math.PI / -2.36, 0, 0],
  textScale: 0.3,
  decalSize: 0.1,
  letterSpacing: 0.05,
  fontWeight: 500,
  aspectRatio: [3, 1],
};
export {
  modelParts,
  leftLogoCoords,
  rightLogoCoords,
  leftLogoParts,
  rightLogoParts,
  numberCoords,
};
